<template>
    <div>
        <form @submit.prevent="handleSubmit">
            <div>
                <div class="row mb-3">
                    <div class="col-lg-4">
                        <label for="client" class="form-label">Cliente</label>
                        <select id="client" v-model="selectedClient" @change="loadProjects" class="form-control"
                            required>
                            <option value="" selected disabled>{{ selectedClientText }}</option>
                            <option v-for="client in clients" :key="client.id" :value="client.client_id">
                                {{ client.client }}
                            </option>
                        </select>
                    </div>
                    <div class="col-lg-8">
                        <label for="project" class="form-label">Proyecto</label>
                        <select id="project" v-model="selectedProject" @change="loadActivities" class="form-control"
                            :disabled="!selectedClient" required>
                            <option value="" selected disabled>{{ selectProjectText }}</option>
                            <option v-for="project in projects" :key="project.id" :value="project.project_id">
                                {{ project.identifier }} - {{ project.project }}
                            </option>
                        </select>
                    </div>
                </div>
                <div class="row mb-3">
                    <div class="col-lg-8">
                        <label for="activity" class="form-label">Actividad:</label>
                        <select v-model="selectedActivity" class="form-control" required>
                            <option value="" selected disabled>{{ selectedActivityText }}</option>
                            <option v-for="act in activities" :key="act.activity_id" :value="act.activity_id">
                                {{ act.activity }}
                            </option>
                        </select>
                    </div>
                    <div class="col-lg-4">
                        <label for="eventDate" class="form-label">Fecha:</label>
                        <input type="date" id="eventDate" v-model="eventData.date" class="form-control" required />
                    </div>
                </div>
                <div class="row mb-3">
                    <div class="mb-3 col-lg-6">
                        <label for="eventStartTime" class="form-label">Hora de
                            Inicio:</label>
                        <input type="time" id="eventStartTime" v-model="eventData.start_time" class="form-control"
                            required />
                    </div>
                    <div class="mb-3 col-lg-6">
                        <label for="eventEndTime" class="form-label">Hora de
                            Finalización:</label>
                        <input type="time" id="eventEndTime" v-model="eventData.end_time" class="form-control"
                            required />
                    </div>
                </div>

                <div class="row mb-3">
                    <div class="col-lg-6 d-flex align-items-end  justify-content-center">
                        <div class="me-2 mt-1">Es Tiempo Extra?</div>
                        <div class="form-check form-switch mb-0 ms-2">
                            <input v-model="eventData.is_extra_time" class="form-check-input form-check-input-warning"
                                type="checkbox" @change="toggleIsIncident" />
                        </div>
                    </div>
                    <div v-if ="showOnSite" class="col-lg-6 d-flex align-items-end  justify-content-center">
                        <div class="me-2 mt-1">En Planta?</div>
                        <div class="form-check form-switch mb-0 ms-2">
                            <input v-model="eventData.on_site" class="form-check-input form-check-input-warning"
                                type="checkbox" />
                        </div>
                    </div>
                </div>
                <div class="mb-4">
                    <label for="notes" class="form-label">Notas:</label>
                    <input type="text" id="notes" v-model="eventData.notes" class="form-control" />
                </div>
                <button size="lg" type="submit" class="btn btn-warning w-100 mb-0">+ Registrar</button>
            </div>
        </form>
    </div>
</template>

<script setup>

import { onMounted, ref, defineProps } from 'vue';

import axios from 'axios';
const token = localStorage.getItem('authToken'); // Obtén el token del localStorage
const API_BASE_URL = process.env.VUE_APP_BASE_URL;

const props = defineProps({
    selectedData: Object,
});

const eventData = ref({
    date: '',
    start_time: '',
    end_time: '',
    is_billable: false,
    on_site: false,
    client_id: null,
    project_id: null,
    activity_id: null,
    notes: '',
    is_extra_time: false,
});

const isNexon = ref(false)
const showOnSite = ref(true)

const selectedClient = ref("");
const selectedProject = ref("");
const selectedActivity = ref("");

const clients = ref([]);
const projects = ref([]);
const activities = ref([]);
const incident_codes = ref([])

const selectedClientText = ref("Cliente")
const selectProjectText = ref("Proyecto")
const selectedActivityText = ref("Selecciona Actividad")


const verifyIsNexon = (clientId) => {
    if (clientId === 2) {
        isNexon.value = true
        showOnSite.value = false
    } else {
        showOnSite.value = true
    }
}

const loadClients = async () => {
    try {
        const response = await axios.post(`${API_BASE_URL}/clients-user-projects`, {}, {
            headers: {
                Authorization: `Bearer ${token}`, // Agrega el token en el header
            },
        });
        clients.value = response.data;
    } catch (error) {
        console.error('Error al obtener los datos de clientes:', error);
    }
};

const loadProjects = async () => {
    if (!selectedClient.value) return;
    verifyIsNexon(selectedClient.value)
    try {
        const response = await axios.post(`${API_BASE_URL}/user-projects`, { client_id: selectedClient.value }, {
            headers: {
                Authorization: `Bearer ${token}`, // Agrega el token en el header
            },
        });
        projects.value = response.data;
    } catch (error) {
        console.error('Error al obtener los datos de clientes:', error);
    }
};

const loadActivities = async () => {
    try {
        const response = await axios.get(`${API_BASE_URL}/user-activities`, {
            headers: {
                Authorization: `Bearer ${token}`, // Agrega el token en el header
            },
        });
        activities.value = response.data; // Asigna los datos a variable `time_records`
    } catch (error) {
        console.error('Error al obtener los datos:', error);
    }
}

const loadIncidents = async () => {
    try {
        const response = await axios.post(`${API_BASE_URL}/get-incident-codes`, {}, {
            headers: {
                Authorization: `Bearer ${token}`, // Agrega el token en el header
            },
        });
        incident_codes.value = response.data; // Asigna los datos a variable `time_records`
    } catch (error) {
        console.error('Error al obtener los datos:', error);
    }
}

const handleSubmit = async () => {
    await addEvent()
}

const addEvent = async () => {
    
    eventData.value.client_id = selectedClient.value;
    eventData.value.project_id = selectedProject.value;
    eventData.value.activity_id = selectedActivity.value;

    // Convertir start_time y end_time a objetos Date
    const startTime = new Date(`1970-01-01T${eventData.value.start_time}Z`);
    let endTime = new Date(`1970-01-01T${eventData.value.end_time}Z`);

    // Validación para asegurarse de que start_time sea menor que end_time
    if (startTime >= endTime) {
        alert('La hora de inicio debe ser menor que la hora de fin.');
        return; // Detiene la ejecución si la validación falla
    }

    try {
        const response = await axios.post(`${API_BASE_URL}/set-time-record`, eventData.value, {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        });

        if (response.status === 200) {
            alert('Evento Registrado');
            window.location.reload();
        }
    } catch (error) {
        console.error('Error al registrar la actividad:', error);
        // Verificar si hay respuesta del servidor
        if (error.response) {
            alert(error.response.data.msg || 'Ocurrió un error al registrar el evento.');
        } else {
            alert('Error de conexión con el servidor.');
        }
    }
};


onMounted(async () => {
    await loadClients();
    await loadActivities();
    await loadIncidents();
    eventData.value = { ...props.selectedData };
});

</script>
